import { useGetRulesQuery } from '../api';
import { IPolicyRule } from '../model/types';

export const useRules = (policyId?: string) => {
  const query = policyId ? `filter[policy_id]=${policyId}` : undefined;
  const { data, isLoading, isError, error, isFetching, refetch } = useGetRulesQuery(query, {
    skip: !policyId,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  return {
    rules: (data?.data ?? []) as IPolicyRule[],
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  };
};
